<template>
  <v-row justify="center">
        <v-dialog v-model="show" max-width="400px">
            <v-card>
                <v-card-title style="justify-content: center;">{{ $t("return.confirmationRefund") }}</v-card-title>
                <v-card-text>{{ $t("return.refundModalText") }}</v-card-text>
                    <v-card-text>
                      {{ $t("return.refundAmount") }} : {{refund | formatPrice(currency)}} {{currency.code}}
                    </v-card-text>
                  <v-card-actions class="pa-0">
                    <v-btn
                        color="primary"
                        tile
                        @click="validate()"
                        style="width: 50%;"
                    >{{$t('return.validate')}}
                    </v-btn>
                    <v-btn
                        color="secondary"
                        tile
                        class="ml-0"
                        style="width: 50%;"
                        @click="close()"
                    >{{$t("return.close")}}
                    </v-btn>
                  </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>


<script>
export default {
  name: "confirmationRefundDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    refund: {
      type: Number,
      default: undefined
    },
    currency: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
  },
  methods: {
      validate(){
        this.$emit("validate")
        this.show = false;
      },
      close(){
        this.$emit("close")
      },
    }
};
</script>
<style scoped>
.w-45 {
  width: 45%;
}
</style>
